import React from 'react';
import './CustomOffcanvas.scss';

export default function CustomOffcanvas({
  isOpen,
  toggle,
  width = '30vw',
  backdrop = true,
  scrollable = true,
  direction = 'end',
  children,
}) {
  return (
    <>
      {backdrop && isOpen && (
        <div className="custom-offcanvas-backdrop" onClick={toggle} />
      )}
      <div
        className={[
          'custom-offcanvas',
          `custom-offcanvas-${direction}`,
          isOpen ? 'open' : '',
          scrollable ? 'scrollable' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        style={{ width }}
      >
        {children}
      </div>
    </>
  );
}
